import { useEffect, useState } from "react";
import SideBar from "../../components/SideBar";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import LogOutModal from "../../components/modals/LogOutModal";
import SystemLogsTable from "../../components/tables/SystemLogsTable";
import { useDispatch, useSelector } from "react-redux";
import { getLogs } from "../../redux/actions/logs";
import { authanticatedUser } from "../../utils/helper";

const SystemLogsIndex = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { logs, loading } = useSelector((state) => state.logs);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(getLogs({token: authanticatedUser.token}))
  }, [])

  const pageTitle = "System Logs";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "System Logs" }];

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar
        options={{ open, toggleLogOutModal }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
          <SystemLogsTable logs={logs}/>
          <Footer />
        </div>
      </main>
      <LogOutModal options={{ open, setOpen, toggleLogOutModal }} />
    </div>
  );
};

export default SystemLogsIndex;
